(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["oskina-blog"] && !Shopify.designMode) return;
  try {
    
  const initOskinaBlog = (root) => {
    if (!root || root.dataset.oskinaBlogReady === 'true') return;

    const scroller = root.querySelector('[data-oskina-blog-scroller]');
    const status = root.querySelector('[data-oskina-blog-status]');
    const prev = root.querySelector('[data-oskina-blog-prev]');
    const next = root.querySelector('[data-oskina-blog-next]');
    if (!scroller) return;

    const items = Array.from(scroller.children);
    if (items.length === 0) return;

    root.dataset.oskinaBlogReady = 'true';

    const indexFromScroll = () => {
      const width = items[0].getBoundingClientRect().width;
      if (!width) return 0;
      return Math.min(items.length - 1, Math.max(0, Math.round(scroller.scrollLeft / width)));
    };

    const update = () => {
      if (!status) return;
      status.textContent = `${indexFromScroll() + 1}/${items.length}`;
    };

    const go = (dir) => {
      const nextIndex = Math.min(items.length - 1, Math.max(0, indexFromScroll() + dir));
      items[nextIndex].scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
    };

    prev?.addEventListener('click', () => go(-1));
    next?.addEventListener('click', () => go(1));
    scroller.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  };

  const bootOskinaBlog = () => {
    document.querySelectorAll('[data-oskina-blog]').forEach((root) => {
      root.dataset.oskinaBlogReady = '';
      initOskinaBlog(root);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootOskinaBlog);
  } else {
    bootOskinaBlog();
  }

  document.addEventListener('shopify:section:load', (event) => {
    const root = event.target.querySelector('[data-oskina-blog]') || event.target.closest('[data-oskina-blog]');
    if (root) {
      root.dataset.oskinaBlogReady = '';
      initOskinaBlog(root);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["oskina-footer"] && !Shopify.designMode) return;
  try {
    
  const syncOskinaFooterAcc = () => {
    const desktop = window.matchMedia('(min-width: 900px)').matches;
    document.querySelectorAll('.oskina-footer__acc').forEach((el) => {
      if (desktop) el.setAttribute('open', '');
      else el.removeAttribute('open');
    });
  };

  syncOskinaFooterAcc();
  window.addEventListener('resize', syncOskinaFooterAcc);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["oskina-ugc"] && !Shopify.designMode) return;
  try {
    
  const initOskinaUgc = (root) => {
    if (!root || root.dataset.oskinaUgcReady === 'true') return;

    const track = root.querySelector('[data-oskina-ugc-track]');
    const set = root.querySelector('[data-oskina-ugc-set]');
    if (!track || !set || set.children.length === 0) return;

    if (typeof root._oskinaUgcCleanup === 'function') {
      root._oskinaUgcCleanup();
    }

    root.dataset.oskinaUgcReady = 'true';

    const autoplay = root.dataset.autoplay === 'true';
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const designMode = Boolean(window.Shopify && window.Shopify.designMode);
    const canMarquee = autoplay && !reduceMotion && !designMode && set.children.length > 1;

    const playVideos = (scope) => {
      scope.querySelectorAll('video').forEach((video) => {
        video.muted = true;
        video.loop = true;
        video.playsInline = true;
        if (!video.dataset.oskinaLoopBound) {
          video.dataset.oskinaLoopBound = 'true';
          video.addEventListener('ended', () => {
            video.currentTime = 0;
            video.play().catch(() => {});
          });
        }
        video.play().catch(() => {});
      });
    };

    const measureShift = () => {
      const gap = parseFloat(getComputedStyle(set).marginRight) || 0;
      const shift = Math.round(set.getBoundingClientRect().width + gap);
      if (shift > 0) root.style.setProperty('--ugc-shift', `${shift}px`);
    };

    window.requestAnimationFrame(measureShift);

    playVideos(set);

    if (canMarquee && !track.querySelector('[data-oskina-ugc-clone]')) {
      const clone = set.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      clone.setAttribute('data-oskina-ugc-clone', 'true');
      clone.querySelectorAll('[id]').forEach((el) => el.removeAttribute('id'));
      track.appendChild(clone);
      playVideos(clone);
    }

    if (canMarquee) {
      root.classList.add('is-marquee');
      measureShift();
    } else {
      root.classList.remove('is-marquee');
    }

    const pause = () => root.classList.add('is-paused');
    const resume = () => root.classList.remove('is-paused');

    const io = new IntersectionObserver((entries) => {
      const visible = entries.some((entry) => entry.isIntersecting);
      if (visible) {
        resume();
        playVideos(root);
      } else {
        pause();
      }
    }, { threshold: 0.2 });

    io.observe(root);

    const onVisibility = () => {
      if (document.hidden) pause();
      else resume();
    };

    document.addEventListener('visibilitychange', onVisibility);
    window.addEventListener('resize', measureShift);

    root._oskinaUgcCleanup = () => {
      io.disconnect();
      document.removeEventListener('visibilitychange', onVisibility);
      window.removeEventListener('resize', measureShift);
      root.classList.remove('is-marquee', 'is-paused');
      track.querySelectorAll('[data-oskina-ugc-clone]').forEach((clone) => clone.remove());
    };
  };

  const bootOskinaUgc = () => {
    document.querySelectorAll('[data-oskina-ugc]').forEach((root) => {
      root.dataset.oskinaUgcReady = '';
      initOskinaUgc(root);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootOskinaUgc);
  } else {
    bootOskinaUgc();
  }

  document.addEventListener('shopify:section:load', (event) => {
    const root = event.target.querySelector('[data-oskina-ugc]') || event.target.closest('[data-oskina-ugc]');
    if (root) {
      root.dataset.oskinaUgcReady = '';
      initOskinaUgc(root);
    }
  });

  } catch(e) { console.error(e); }
})();
})();
